/** Extractors and model proposals keep both reminder offsets exactly, or reject them. */
export function agendaReminderOffsets(value: unknown, scalar?: unknown): number[] {
  const raw = value === undefined || value === null ? (scalar === undefined || scalar === null ? [] : [scalar]) : value;
  if (!Array.isArray(raw) || raw.length > 2 || raw.some(item => !Number.isInteger(item) || Number(item) < 0 || Number(item) > 10080) || new Set(raw).size !== raw.length) throw new Error("invalid_agenda_reminders");
  return raw as number[];
}

/** Calendar destination labels never become a physical venue by inference. */
export function agendaCaptureLocation(value: unknown, transcript: string): string | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  const fold = (text: string) => text.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase()
    .replace(/[\p{P}\p{S}]/gu, ' ').replace(/\s+/gu, ' ').trim();
  const location = fold(value);
  const calendar = '(?:calendario|calendar|agenda|kalender|calendrier|kalendarz)';
  if (!new RegExp('^(?:' + calendar + '(?: do| da| de| van| di| du| del)? vyv|vyv ' + calendar + ')$', 'u').test(location)) return value;
  const literalLocation = /(?:^|[\s.])(?:local|localização|localizacao|location|locatie|lieu|luogo|ort|miejsce)\s*:\s*([^\n;.!?]+)/iu.exec(transcript);
  return literalLocation && fold(literalLocation[1]).startsWith(location) ? value : null;
}
